import { Avatar, Box, Skeleton } from '@mui/material';
import {
  hashNumberFromString,
  teamsColorPalette,
} from 'components/Header/HeaderMenuToggle/HeaderMenuContent/TeamsMenu/utils';
import { useGetUserAvatar } from 'hooks/queries/useGetUserAvatar';
import { CSSProperties, FunctionComponent, PropsWithChildren, useMemo } from 'react';
import { ErrorMessage } from 'shared/ErrorMessage';

interface UserTeamAvatarProps {
  className?: string;
  style?: CSSProperties;
}

export const UserTeamAvatar: FunctionComponent<PropsWithChildren<UserTeamAvatarProps>> = ({ className }) => {
  const { data, loading, error } = useGetUserAvatar();

  const avatarData = useMemo(() => {
    if (!data) return null;

    const { picture, email, name: userName } = data.sessionUser;
    const { numUsers, _id: teamPrettyId, name: teamName } = data.sessionTeam;
    const teamColorIndex = hashNumberFromString(teamPrettyId) % teamsColorPalette.length;
    const teamColor = teamsColorPalette[teamColorIndex];

    return {
      picture,
      email,
      userName,
      numUsers,
      teamPrettyId,
      teamName,
      teamColor,
    };
  }, [data]);

  if (loading) {
    return <Skeleton variant="circular" width={40} height={40} />;
  }

  if (error || !data || !avatarData) {
    return <ErrorMessage />;
  }

  const { picture, email, userName, numUsers, teamName, teamColor } = avatarData;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }} className={className}>
      <Avatar src={picture?.url}>{picture ? null : userName?.[0]?.toUpperCase() || email?.[0] || 'U'}</Avatar>
      {numUsers !== null && numUsers > 1 && (
        <Box component={Avatar} sx={{ marginLeft: '-0.75rem', backgroundColor: teamColor }}>
          {teamName?.[0].toUpperCase() || email?.[0] || 'T'}
        </Box>
      )}
    </Box>
  );
};
